const euroCurrencyFormatter = Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'});
export const formatCurrency = (amountInCents: number) => euroCurrencyFormatter.format(amountInCents / 100);